export const TINY_MCE_KEY = 'pge04lgcxrr3kseb5qw383mylpykrqftfibm3873t6gcmdoz';
